import React from "react";
import { Link } from "react-router-dom";
import BottomNav from "../components/bottom-nav";
import { cn } from "../lib/utils";
import { Navbar } from "../components/navbar";
import { API_BASE_URL } from "../lib/constants";

function HomeLayout({ children, className, style }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="app-root flex-1 pt-[80px] lg:pt-[88px] py-4 md:py-8 xl:py-12 bg-gradient-to-br from-white via-[hsl(var(--gradient))]/10 to-white dark:bg-black overflow-y-auto">
        <main
          className={cn(
            "my-4 p-y-2 md:py-3 lg:py-4 px-2 md:px-10 lg:px-24 2xl:px-[200px]",
            className
          )}
          style={{
            ...style,
          }}
        >
          {children}
        </main>
        <BottomNav />
      </div>
    </div>
  );
}

export default HomeLayout;

export const Logo = ({ className, size, variant = "default" }) => {
  // For navbar variant, use the parent's height classes instead of default
  const imgClassName = variant === "navbar" ? "h-full" : "h-24 md:h-28 lg:h-32";

  return (
    <Link to="/" className={cn("logo flex gap-2 items-start hover:opacity-80 transition-opacity", className)}>
      <img
        src={API_BASE_URL + "/frontend_assets/logo.png"}
        className={imgClassName}
        alt="the african polyglot logo"
      />

      {/* OLD Logo

      <Globe2 className="stroke-primary drop-shadow-lg mt-1" />
      <a href="/" className="flex flex-col justify-start items-center">
        <h1
          className={cn(
            "font-extrabold text-primary text-nowrap",
            africanTitleClassName
          )}
        >
          Ŋwɑ̀'nǐ Njá'ghə̀ə̀
        </h1>{" "}
        <h2
          className={cn(
            "text-[#333333ee] text-center italic font-medium",
            englishTitleClassName
          )}
        >
          The African Polyglot
        </h2>
      </a> */}
    </Link>
  );
};
